import React from "react";
import kid from "./kids.jpg";

function Kids() {
  return (
    <div class="wrapper">
      <div class="title">
        <h4 style={{ textAlign: "center" }}>
          <span>
            voici le menu enfant N'hésitez pas appelez le 09 50 85 13 53
          </span>
          1-Menu kids{" "}
        </h4>
      </div>
      <div class="menu">
        <div class="single-menu">
          <img src={kid} alt="" />
          <div class="menu-content">
            <h4>
              {" "}
              Menu enfant <span>5.5€</span>
            </h4>
            <p>Cheese burger ou 5 nuggets + frites + caprisun</p>
          </div>
        </div>
      </div>

      <div class="title">
        <h4 style={{ textAlign: "center" }}>2-Panini et Sandwish au four </h4>
      </div>
      <div class="menu">
        <div class="single-menu">
          <img
            src="https://www.unecuillereenbois.fr/wp-content/uploads/2020/03/pain-panini-recette.png"
            alt=""
          />
          <div class="menu-content">
            <h4>
              {" "}
              Panini au choix <span>5.5€</span>
            </h4>
            <p>
              toutes les viandes ainsi les paninis 3 fromages et thon, servi
              avec frite, le menu à 6€
            </p>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://sandwichs24pizza.fr/wp-content/uploads/2020/01/Grec-four-Sandwichs24Pizza.png"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Sandwish au four <span>7€</span>
            </h4>
            <p>Une viande au choix avec mozzarella</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Kids;
